import React, { useEffect, useState } from "react";
import DataTable, { defaultThemes } from "react-data-table-component";
import { ApiGet, ApiPut } from "../../../helpers/API/ApiData";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import Loader from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";

const User = ({ title }) => {
    const [filteredAdmin, setFilteredAdmin] = useState({});
    const [isLoaderVisible, setIsLoaderVisible] = useState(false);
    const [show, setShow] = useState(false);
    const [idForEditStatus, setIdForEditStatus] = useState("");
    const [status, setStatus] = useState("");

    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [countPerPage, setCountPerPage] = useState(10);
    const [search, setSearch] = useState("");

    const handleClose = () => {
        setShow(false);
    };


    useEffect(() => {
        title === "Dashboard | OUR LEISURE HOME" ? document.title = title : document.title = "User | OUR LEISURE HOME"
    }, [])

    useEffect(() => {
        getAllAdmins();
    }, [page, countPerPage]);

    const getAllAdmins = async () => {
        setIsLoaderVisible(true);
        if (!search) {
            await ApiGet(`admin/get-users?page=${page}&limit=${countPerPage}`)
                .then((res) => {
                    setIsLoaderVisible(false);
                    setFilteredAdmin(res?.data?.payload?.user);
                    setCount(res?.data?.payload?.count);
                })
                .catch((err) => {
                    toast.error(err);
                });
        } else {
            await ApiGet(`admin/get-users?search=${search}&page=${page}&limit=${countPerPage}`)
                .then((res) => {
                    setIsLoaderVisible(false);
                    setFilteredAdmin(res?.data?.payload?.user);
                    setCount(res?.data?.payload?.count);
                })
                .catch((err) => {
                    toast.error(err);
                });
        }

    };

    const handleEditStatus = () => {
        let data = {
            status: status,
            id: idForEditStatus,
        };
        ApiPut(`admin/block`, data)
            .then((res) => {
                if (res?.status == 200) {
                    setShow(false);
                    toast.success("Status Updated Successfully");
                    setStatus("");
                    setIdForEditStatus("");
                    getAllAdmins();
                } else {
                    toast.error(res?.data?.message);
                }
            })
            .catch((err) => {
                toast.error(err.message);
            });
    };

    let i = 0;
    const columns = [
        {
            name: "SNo",
            cell: (row, index) => index + 1,
            width:"55px"
        },
        {
            name: "Email",
            selector: "email",
            cell: (row) => {
                return (
                  <>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: row?.email,
                      }}
                      className=""
                    />
                  </>
                );
              },
        },
        {
            name: "First Name",
            selector: "fname",
            sortable: true,
        },
        {
            name: "Last Name",
            selector: "lname",
            sortable: true,
        },
        {
            name: "Phone No.",
            selector: "phone",
            sortable: true,
        },
        {
            name: "Status",
            cell: (row) => {
                return (
                    <>
                        <div className="d-flex justify-content-between cus-medium-button-style">
                            <button
                                className="cursor-pointer"
                                onClick={() => {
                                    setShow(true);
                                    setIdForEditStatus(row?._id);
                                    setStatus(
                                        row?.status?.name == "active" ? "inactive" : "active"
                                    );
                                }}
                            >
                                {row?.status?.name == "active" ? "Active" : "Inactive"}
                            </button>
                        </div>
                    </>
                );
            },
            sortable: true,
            selector: (row) => row?.status?.name,
        },
    ];
    // * Table Style
    const customStyles = {
        header: {
            style: {
                minHeight: "56px",
            },
        },
        headRow: {
            style: {
                borderTopStyle: "solid",
                borderTopWidth: "1px",
                borderTopColor: defaultThemes.default.divider.default,
            },
        },
        headCells: {
            style: {
                "&:not(:last-of-type)": {
                    borderRightStyle: "solid",
                    borderRightWidth: "1px",
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {
            style: {
                "&:not(:last-of-type)": {
                    borderRightStyle: "solid",
                    borderRightWidth: "1px",
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
    };

    //for search data

    const handleSearch = (e) => {
        setSearch(e.target.value);
    };

    const debouncedSearchTerm = useDebounce(search, 500);

    // Hook
    function useDebounce(value, delay) {
        // State and setters for debounced value
        const [debouncedValue, setDebouncedValue] = useState(value);
        useEffect(
            () => {
                // Update debounced value after delay
                const handler = setTimeout(() => {
                    setDebouncedValue(value);
                }, delay);
                // Cancel the timeout if value changes (also on delay change or unmount)
                // This is how we prevent debounced value from updating if value is changed ...
                // .. within the delay period. Timeout gets cleared and restarted.
                return () => {
                    clearTimeout(handler);
                };
            },
            [value, delay] // Only re-call effect if value or delay changes
        );
        return debouncedValue;
    }

    useEffect(() => {
        if (debouncedSearchTerm) {
            setIsLoaderVisible(true);
            setPage(1);
            setCount(0);
            setCountPerPage(countPerPage);
            getAllAdmins();
        } else {
            setPage(1);
            setCount(0);
            setCountPerPage(countPerPage);
            getAllAdmins();
        }
    }, [debouncedSearchTerm]);

    return (
        <>
            <div className="card p-1">
                <ToastContainer />
                <div className="p-2 mb-2">
                    <div className="row mb-4 pr-3">
                        <div className="col-md-3 col-sm-12 d-flex justify-content-between">
                            <h2 className="pl-3 pt-2">User Listing</h2>
                        </div>
                        <div className="col-md-5 col-sm-12">
                            <div>
                                <input
                                    type="text"
                                    className={`form-control form-control-lg form-control-solid `}
                                    name="title"
                                    placeholder="Search Users"
                                    onChange={(e) => handleSearch(e)}
                                />
                            </div>
                        </div>
                    </div>

                    {/* status */}
                    <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className="text-danger">Alert!</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want To {status === "active" ? "Active" : "Inactive"} {" "}
                             this user
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Cancel
                            </Button>
                            <Button
                                variant="danger"
                                onClick={(e) => {
                                    handleEditStatus()
                                }}
                            >
                                {status === "active" ? "Active" : "Inactive"}
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <DataTable
                        columns={columns}
                        data={filteredAdmin}
                        customStyles={customStyles}
                        style={{
                            marginTop: "-3rem",
                        }}
                        progressPending={isLoaderVisible}
                        progressComponent={
                            <Loader type="Puff" color="#334D52" height={30} width={30} />
                        }
                        highlightOnHover
                        pagination
                        paginationServer
                        paginationTotalRows={count}
                        paginationPerPage={countPerPage}
                        paginationRowsPerPageOptions={[10, 20, 25, 50, 100]}
                        paginationDefaultPage={page}
                        onChangePage={(page) => {
                            setPage(page);
                        }}
                        onChangeRowsPerPage={(rowPerPage) => {
                            setCountPerPage(rowPerPage);
                        }}
                    />
                </div>
            </div>
        </>
    );
};

export default User;
